import { createSelector } from "@reduxjs/toolkit";

export const selectLocalPatientsState = (state) => state.localPatients;

export const selectAllLocalPatients = createSelector(
  selectLocalPatientsState,
  (localPatientsState) =>
    (localPatientsState?.allIds || []).map((id) => localPatientsState.byId[id])
);

export const selectLocalPatientById = (patientId) =>
  createSelector(selectLocalPatientsState, (localPatientsState) =>
    localPatientsState?.byId?.[patientId] || null
  );

export const selectLocalPatientsLoading = createSelector(
  selectLocalPatientsState,
  (localPatientsState) => Boolean(localPatientsState?.loading)
);

export const selectLocalPatientsLoaded = createSelector(
  selectLocalPatientsState,
  (localPatientsState) => Boolean(localPatientsState?.loaded)
);

export const selectLocalPatientsError = createSelector(
  selectLocalPatientsState,
  (localPatientsState) => localPatientsState?.error || null
);
